import { render, staticRenderFns } from "./serial_code_table.vue?vue&type=template&id=096b387e"
import script from "./serial_code_table.vue?vue&type=script&lang=ts"
export * from "./serial_code_table.vue?vue&type=script&lang=ts"
import style0 from "./serial_code_table.vue?vue&type=style&index=0&id=096b387e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports